// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3a847bc1","842":"ecdc8ad9"}[chunkId] + ".chunk.js";
};